import React from "react";
import { Box, MainTitle, PressableOpacity } from "app/components/common";
import ArrowLeft from "../Icons/Arrow/ArrowLeft";
import { useNavigation } from "@react-navigation/native";
import theme from "app/Theme/Theme";

interface Props {
  title: string;
}

const MainHeader = ({ title = "" }: Props) => {
  const navigation = useNavigation();

  const handleNavigateBack = () => navigation.goBack();

  return (
    <Box
      paddingHorizontal="sm"
      width="100%"
      flexDirection="row"
      marginTop="sm"
      alignItems="flex-start"
      marginBottom="sm"
    >
      <PressableOpacity
        style={{ marginTop: theme.spacing.xxs }}
        onPress={handleNavigateBack}
      >
        <ArrowLeft color={theme.colors["neutral.900"]} />
      </PressableOpacity>
      <Box width="70%">
        <MainTitle marginLeft="s" variant="l8-bold">
          {title}
        </MainTitle>
      </Box>
    </Box>
  );
};

export default MainHeader;
